import * as React from 'react';
import {Project, ProjectStatus} from '../../../store/projects/commonTypes';
import {Option} from '../../../store/common-values/commonTypes';
import {DataGrid, GridCellParams, GridColDef} from '@mui/x-data-grid';
import {dateTimeFormatter, dateTimeGetter, projectStatusFormatter} from '../../../utils/utils';
import {Autocomplete, Button, Link, TextField} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export interface ProjectsListProps {
    projects: Project[];
    projectStatuses: Option[];
    onOpenNewForm: () => void;
    onOpenDetails: (number: string) => void;
}

export interface ProjectsListState {
    projects: Project[];
    projectStatuses: Option[];
    searchText?: string;
    statusFilter?: ProjectStatus;

}

export default class ProjectsList extends React.Component<ProjectsListProps, ProjectsListState> {
    constructor(props: ProjectsListProps) {
        super(props);

        this.state = {
            projects: props.projects || [],
            projectStatuses: props.projectStatuses || []
        };
    }

    componentDidUpdate(prevProps: ProjectsListProps) {
        if (this.props.projects?.length !== prevProps.projects?.length) {
            this.setState({ projects: this.props.projects || [] });
        }

        if (this.props.projectStatuses?.length !== prevProps.projectStatuses?.length) {
            this.setState({ projectStatuses: this.props.projectStatuses || [] });
        }
    }

    private filterProject(project: Project): boolean {
        if (this.state.searchText) {
            if (`${project.name}  ${project.projectNumber}  ${project.status}  ${project.breeamVersion}`.toLowerCase().indexOf(this.state.searchText.toLowerCase()) == -1) return false;
        }

        if (this.state.statusFilter) {
            if (project.projectStatus != this.state.statusFilter) return false;
        }

        return true;
    }

    public render() {
        const columns: GridColDef[] = [
            {
                field: 'name', headerName: 'Prosjekt', width: 300,
                renderCell: (params: GridCellParams) => (
                    ((params.row as Project).projectStatus == ProjectStatus.onReview ? params.formattedValue : (
                        <Link href="#" onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                            e.preventDefault();
                            this.props.onOpenDetails((params.row as Project).id);
                        }
                        } >{params.formattedValue}</Link>
                    ))
                ),
            },
            { field: 'projectNumber', headerName: 'ID', width: 200 },
            { field: 'breeamVersion', headerName: 'BREEAM-NOR versjon', width: 150 },
            { field: 'created', headerName: 'Dato opprettet', width: 150, valueGetter: dateTimeGetter, valueFormatter: dateTimeFormatter },
            { field: 'modified', headerName: 'Siste endringer', width: 150, valueGetter: dateTimeGetter, valueFormatter: dateTimeFormatter },
            { field: 'projectStatus', headerName: 'Status', width: 200, valueFormatter: projectStatusFormatter }
        ];

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-3 mb-3">
                        <TextField
                            label="Søk"
                            type="search"
                            fullWidth
                            variant="standard"
                            value={this.state.searchText}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.setState({ searchText: event.target.value })}
                        />
                    </div>
                    <div className="col-sm-3 mb-3">
                        <Autocomplete
                            options={this.state.projectStatuses}
                            getOptionLabel={(option: Option) => option.label}
                            onChange={(e, status) => this.setState({ statusFilter: status?.id as number })}
                            renderInput={(params) => <TextField {...params} variant="standard" label="Filtrer etter statuser" />}
                        />
                    </div>
                    <div className="col-sm-6 mb-3 d-flex align-items-center justify-content-end">
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={(event: React.MouseEvent<HTMLButtonElement, Event>) => this.props.onOpenNewForm()}
                            startIcon={<AddIcon />}
                        >
                            Legg til prosjekt
                        </Button>
                    </div>
                </div>
                <div className="table-container">
                    <DataGrid columns={columns} rows={this.state.projects.filter(i => this.filterProject(i))} hideFooter hideFooterPagination autoHeight disableSelectionOnClick={true} />
                </div>
            </React.Fragment >
        );
    }
}
